import { Image, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GiftPreviewModal } from '@hero/components/modals';

import * as S from './style';

function GiftPreviewBox({
  previewLink,
  giftWrapperUrl,
  digitalGreetingCard = null,
  isModalShown = true
}) {
  const { t } = useTranslation();
  const [isShowGiftPreviewModal, setIsShowGiftPreviewModal] = useState(false);

  const handleOpenPreview = () => {
    if (isModalShown) setIsShowGiftPreviewModal(true);
    else window.open(previewLink, '_blank');
  };

  return (
    <S.GiftPreviewBox>
      <Typography variant="body1Bold">{t('giftPreview')}</Typography>

      <S.GiftView onClick={handleOpenPreview} backgroundImage={giftWrapperUrl}>
        <S.Bow />
        {digitalGreetingCard && (
          <S.DigitalCard>
            <Image src={digitalGreetingCard?.card_image} />
          </S.DigitalCard>
        )}
        <S.PreviewButton>{t('openPreview')}</S.PreviewButton>
      </S.GiftView>
      <GiftPreviewModal
        isModalOpen={isShowGiftPreviewModal}
        onModalOpen={setIsShowGiftPreviewModal}
        previewLink={previewLink}
      />
    </S.GiftPreviewBox>
  );
}

GiftPreviewBox.propTypes = {
  previewLink: PropTypes.string,
  giftWrapperUrl: PropTypes.string,
  digitalGreetingCard: PropTypes.shape({ card_image: PropTypes.string }),
  isModalShown: PropTypes.bool
};

export { GiftPreviewBox };
